<template>
  <div class="modal fade slide-up" id="candidate-multi-action-popup" tabindex="-1" role="dialog" aria-hidden="false" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-header">
            <label class="text-left">
              {{ isManager ? $t(`UserMultiAction.manager.${actionType}`) : $t(`UserMultiAction.${actionType}`) }}
            </label>
          </div>

          <div class="modal-body">
            <div class="checkbox">
              <input
                type="checkbox"
                id="entity_0"
                v-model="toggleAll"
                @change="handleToggle"
              />

              <label for="entity_0">
                {{ toggleAll ? $t('UserMultiAction.deselect_all') : $t('UserMultiAction.select_all') }}
              </label>
            </div>

            <div class="ml-4">
              <div class="checkbox" v-for="entity in entities" :key="entity.id">
                <input
                  v-if="entity.ability"
                  type="checkbox"
                  :id="'entity_' + entity.id"
                  v-model="entity.selected"
                  @change="handleSelection"
                />
                <input
                  v-else
                  type="checkbox"
                  :id="'entity_' + entity.id"
                  disabled
                />


                <label :for="'entity_' + entity.id">{{ entity.name }}</label>
                <div
                  v-if="!entity.ability"
                  :key="'notification_' + entity.id"
                  class="notice">
                  {{ $t('users.messages.user_has_active_offers') }}
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-default btn-cons"
              @click="closePopup">
              {{ $t("UserForm.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-cons"
              @click="handleMultiAction"
              >
              {{ $t("UserForm.submit") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CandidateMultiActionPopup',
    props: ['entityId', 'isManager'],
    data() {
      return {
        toggleAll: false
      }
    },
    computed: {
      ...mapGetters({
        entities: 'users/entitiesForMultiAction',
        actionType: 'users/multiActionType',
        user: 'users/workingUser',
      }),
      selectedEntity() {
        return this.entities.filter(entity => entity.selected)
      }
    },
    methods: {
      handleToggle() {
        const entities = this.entities.map(entity => {
          return { ...entity, selected: entity.ability && this.toggleAll }
        })
        this.$store.commit('users/SET_ENTITIES_FOR_MULTI_ACTION', entities)
      },
      handleSelection() {
        this.toggleAll = this.selectedEntity.length == this.entities.filter(entity => entity.ability).length
      },
      handleMultiAction() {
        const entityIds = this.selectedEntity.map(entity => entity.id)
        if (entityIds.length == 0) {
          return this.closePopup()
        }
        let action = (this.actionType == 'refuse') ? 'delete' : this.actionType;
        const payload = {
          user: this.user,
          entityId: this.entityId,
          entityIds: entityIds
        }
        this.$store.dispatch(`users/${action}User`, payload)

        this.closePopup()
      },
      closePopup() {
        $('#candidate-multi-action-popup').modal('hide')
      }
    },
    watch: {
      entities: function() {
        this.handleSelection()
      }
    },
  }
</script>

<style lang="scss" scoped>
  .modal-header {
    padding: 16px 25px 0 25px;
  }
  .modal-body {
    padding: 8px 25px 0 25px;
    .notice {
      font-size: 12px;
      padding-left: 5px;
    }
  }
  .modal-footer {
    padding: 16px 0;
    margin: 0 25px;
    border-top: 1px solid rgba(#000000, 0.3);
  }
  .addon-title {
    color: #e51349;
    margin-bottom: 0;
  }
  .btn-cons {
    margin-right: 0;
  }
  .checkbox {
    margin: 0 0 12px 0;
    input[type=checkbox]:checked + label:before {
      border-color: #e51349;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidateMultiActionPopup.vue